module.exports = __webpack_public_path__ + "images/tour/welcome.b91ea1839e1c46c9a4cb.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/welcome.svg
// module id = sXmY
// module chunks = 12